import React from 'react';
import { HorizontalGroup, VerticalGroup } from '@libs/uikit/Components';
import { StyledTB } from './StyledTB';
import { Title } from './Title';

export const AdvertisementBars = ({ onClick, active, onOver }) => {
    const onMouseOut = () => onOver(null);
    const onMouseOverShow = () => onOver('showBar');
    const onMouseOverHide = () => onOver('hideBar');
    const toggle = () => onClick(!active);
    return (
        <VerticalGroup style={{ borderLeft: '1px solid #e9ebec', paddingLeft: '32px' }}>
            <Title>Advertisement bars</Title>
            <HorizontalGroup itemShift="0">
                <StyledTB
                    onMouseEnter={onMouseOverShow}
                    onMouseLeave={onMouseOut}
                    onClick={toggle}
                    active={active}
                    size="S"
                >
                    Show
                </StyledTB>
                <StyledTB
                    onMouseEnter={onMouseOverHide}
                    onMouseLeave={onMouseOut}
                    onClick={toggle}
                    active={!active}
                    size="S"
                >
                    Hide
                </StyledTB>
            </HorizontalGroup>
        </VerticalGroup>
    );
};
